// ===================================
// CATEGORY API SERVICE
// src/services/categoryApi.js
// Frontend API calls for categories
// ===================================

import api from './api';

/**
 * Get all active categories
 */
export const getCategories = async () => {
  const response = await api.get('/categories');
  return response.data;
};

/**
 * Get category with subcategories
 */
export const getCategory = async (slug) => {
  const response = await api.get(`/categories/${slug}`);
  return response.data;
};

/**
 * Get subcategories for a category
 */
export const getSubcategories = async (categorySlug) => {
  const response = await api.get(`/categories/${categorySlug}/subcategories`);
  return response.data;
};

export default {
  getCategories,
  getCategory,
  getSubcategories
};
